export default {
  type: 'replace',
  handler: (model, value, attr) => {
    const {
      search,
      replace,
      global
    } = model;
    if (global) {
      return value?.replaceAll(search, replace);
    }
    return value?.replace(search, replace);
  }
};